export const API_BASE_URL = "/api";

export const HEADERS = {
    'Content-Type': 'application/json',
    'Accept': 'application/json',
};

export const MUSIC_BASE_URL = "https://r2-dev.myidecide.net/music";
